<template>
<div v-if="current">
    <messageModal v-if="showMessage" message="Le rapport a été mis à jour" @closeMessage="showMessage = false"></messageModal>
    <div class="row columns">
        <div class="large-3 columns large-centered text-centered panel-title">
            Actions des champions (engagés) :
        </div>
    </div>
    <table>
        <thead class="roster-head">
            <tr>
                <th width="15%">Nom du champion</th>
                <th width="5%">TD</th>
                <th width="5%">Réu</th>
                <th width="5%">Sor</th>
                <th width="5%">Int</th>
                <th width="6%">JPV</th>
                <th width="5%">Agro*</th>
                <th width="5%">Expulsion*</th>
                <th width="15%">Blessure</th>
            </tr>
        </thead>
        <tbody class="roster">
            <tr>
                <td class="small-input">
                    <input type="text" disabled placeholder="puggy" min="0" class="line_input" v-bind:value="current.star_name">
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="current.nb_td">
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="current.nb_pass">
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="current.nb_cas">
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="current.nb_int">
                </td>
                <td class="small-input">
                    <select name="" class="line_input" v-model="current.mvp">
                        <option v-bind:value="true">oui</option>
                        <option v-bind:value="false">non</option>
                    </select>
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="current.nb_foul">
                </td>
                <td class="small-input">
                    <select name=""
                        class="line_input" v-model="current.nb_red_card">
                        <option v-bind:value="0">non</option>
                        <option v-bind:value="1">oui</option>
                    </select>
                </td>
                <td class="small-input">
                    <select name="" id="" class="line_input" v-model="current.injury_type">
                        <option value="null">pas de blessure</option>
                        <option value="0">Commotion</option>
                        <option value="1">Manque le prochain match</option>
                        <option value="2">Blessure persistante</option>
                        <option value="4">-1 en Armure</option>
                        <option value="3">-1 en Mouvement</option>
                        <option value="5">-1 en Agilité</option>
                        <option value="6">-1 en Force</option>
                        <option value="7">la MOOOORT</option>
                    </select>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="row">
        <div class="large-3 columns">
        </div>
        <div class="large-2 columns">
            <button  @click="validate(true)" class="full-width">Enregistrer</button>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import starReport from '../../api/star-report.api'
import messageModal from '../common/message-modal.vue'

export default {
  name: 'rosteredStarReportEditor',
  components: {
    spinner,
    messageModal,
    wizard
  },
  props: {
    'team_report_id': Number,
    'team_id': Number,
    'rostered_star_id': Number,
    'rostered_star_name': String
  },
  data () {
    return {
      'error_msg': null,
      'showMessage': false
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'playerList',
      'starReportList'
    ]),
    current: function () {
      let baseStructure = {
        'star_name': this.rostered_star_name,
        'nb_pass': 0,
        'nb_td': 0,
        'nb_int': 0,
        'nb_cas': 0,
        'mvp': false,
        'nb_foul': 0,
        'nb_blocks': 0,
        'nb_red_card': 0,
        'injury_type': null,
        'team_report': this.team_id,
        'rostered_star_player': this.rostered_star_id,
        'inducement_star_player': null,
        'id': null
      }
      if (this.starReportList === null || this.starReportList.length === 0) {
        return baseStructure
      }
      if (this.starReportList) {
        let found = this.starReportList.find(sr => {
          return sr.rostered_star_player === this.rostered_star_id
        })
        if (found) {
          baseStructure = found
        }
      }
      return baseStructure
    }
  },
  methods: {
    validate (withReload) {
      let report = this.current
      report.star_name = this.rostered_star_name
      report.rostered_star_player = this.rostered_star_id
      report.team_report = this.team_report_id
      if (report.injury_type === 'null') {
        report.injury_type = null
      }
      if (this.current.id === null) {
        this.createReport(report, withReload)
      } else {
        this.updateReport(report, withReload)
      }
    },
    createReport (report, withReload) {
      starReport.api.createStarReport(report).then(response => {
        if (withReload === true) {
          store.dispatch('getStarReportListForTeamReport', this.team_report_id)
        }
        this.isInit = false
        this.showMessage = true
      }, error => {
        console.log('cannot create rostered star report')
        console.log(error)
      })
    },
    updateReport (report, withReload) {
      let reportArray = []
      reportArray.push(report)
      starReport.api.bulkUpdateStarReport(reportArray).then(response => {
        if (withReload === true) {
          store.dispatch('getStarReportListForTeamReport', this.team_report_id)
        }
        this.isInit = false
        this.showMessage = true
      }, error => {
        console.log('cannot update rostered star report')
        console.log(error)
      })
    }
  },
  created () {
    store.dispatch('getStarReportListForTeamReport', this.team_report_id)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.match-team-name {
    font-size: 1.3rem;
}
.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.5rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.note {
 font-size: 0.6rem;
}

</style>



// WEBPACK FOOTER //
// rostered-star-report-editor.vue?c1bf8ea2